module.exports = __webpack_public_path__ + "static/media/tamandare-pe.2cda675b.jpg";